import { Card, Grid, Heading, Separator, Text } from "@radix-ui/themes";
import { FC } from "react";
import { GetOrderResponseType } from "../../../api";
import { getDateFromString } from "../../../functions";

type DetailsProps = Pick<
  GetOrderResponseType,
  "orderID" | "orderDate" | "dateExpected"
>;

export const Details: FC<DetailsProps> = (props) => {
  const { orderID, orderDate, dateExpected } = props;
  return (
    <Card>
      <Heading as="h2">Details zur Bestellung</Heading>
      <Separator my="1" size="4" />
      <Grid columns={{ md: "2" }} gap="2">
        <div>
          <Text as="p" color="gray">
            AB-Auftragsnummer:
          </Text>
          <Text as="p">{orderID}</Text>
        </div>
        <div>
          <Text as="p" color="gray">
            Bestellt am:
          </Text>
          <Text as="p">{getDateFromString(orderDate)}</Text>
        </div>
        {dateExpected && (
          <div>
            <Text as="p" color="gray">
              Wunschlieferdatum:
            </Text>
            <Text as="p">{getDateFromString(dateExpected)}</Text>
          </div>
        )}
      </Grid>
    </Card>
  );
};
